import { render, staticRenderFns } from "./InboxNote.vue?vue&type=template&id=39e59a1a&"
import script from "./InboxNote.vue?vue&type=script&lang=js&"
export * from "./InboxNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports